import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../Modal';

const SessionsDetailModal = ({ onClose, children }) => {
  const { t } = useTranslation('components');

  return (
    <Modal
      title={t('Sessions.SessionsDetailModal.headline')}
      showCloseButton
      onClickCloseButton={onClose}
      onClickOutside={onClose}
    >
      <div data-component="SessionsDetailModal">{children}</div>
    </Modal>
  );
};

SessionsDetailModal.propTypes = {
  moderator: PropTypes.shape({
    reference: PropTypes.string,
    participantId: PropTypes.string,
    fullNameWithTitle: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    avatar: PropTypes.string,
    initials: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.oneOf(['moderator'])),
  }),
  onClose: PropTypes.func,
  children: PropTypes.node,
};

SessionsDetailModal.defaultProps = {
  moderator: {},
  onClose: () => {},
};

export default SessionsDetailModal;
